import { useSeo } from "../lib/useSeo";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ASSETS, BLOG_POSTS } from "../lib/constants";
import { Stagger, StaggerItem } from "../components/Reveal";
import { PageHero } from "../components/bits";

export default function Blog() {
  useSeo("/blog");
  return (
    <div data-testid="blog-page">
      <PageHero
        label="Journal"
        title="The Higher Ground DC Blog"
        subtitle="Education, city guides, and wellness — thoughtfully written for patients new and experienced."
        image={ASSETS.chocPour}
        testid="blog-hero"
      />

      <section className="bg-ink py-20 md:py-28">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
          <Stagger className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {BLOG_POSTS.map((post) => (
              <StaggerItem key={post.slug}>
                <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="group flex h-full flex-col border border-white/10 bg-ink-2 p-8 transition-all duration-500 hover:border-gold/50 hover:bg-ink-3">
                  <span className="text-xs uppercase tracking-[0.22em] text-gold">{post.category}</span>
                  <h2 className="mt-4 font-display text-xl font-light uppercase leading-snug tracking-[0.06em] text-white">{post.title}</h2>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-white/55">{post.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/60 transition-all group-hover:gap-3 group-hover:text-gold">
                    Read More <ArrowRight className="h-4 w-4" />
                  </span>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
